import { render, staticRenderFns } from "./change_domainName.vue?vue&type=template&id=889a4d8e&scoped=true&"
import script from "./change_domainName.vue?vue&type=script&lang=js&"
export * from "./change_domainName.vue?vue&type=script&lang=js&"
import style0 from "./change_domainName.vue?vue&type=style&index=0&id=889a4d8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889a4d8e",
  null
  
)

export default component.exports